// Shared helpers for multiplayer snapshot sync.
// Use this in every virtual game page:
// 1) Deduplicate incoming snapshots before applying UI state.
// 2) Suppress one outbound write right after applying a remote snapshot
//    to prevent write-back echo loops.

export const getVirtualSnapshotSignature = (snapshot) => {
    try {
        return JSON.stringify(snapshot || null);
    } catch {
        return '';
    }
};

export const markVirtualSnapshotSignature = (signatureRef, snapshot) => {
    const signature = getVirtualSnapshotSignature(snapshot);
    if (signatureRef) {
        signatureRef.current = signature;
    }
    return signature;
};

export const isIncomingVirtualSnapshotDifferent = (signatureRef, snapshot) => {
    const signature = getVirtualSnapshotSignature(snapshot);
    return signature !== String(signatureRef?.current || '');
};

export const markRemoteVirtualSnapshotApplied = (signatureRef, suppressWriteRef, snapshot) => {
    markVirtualSnapshotSignature(signatureRef, snapshot);
    if (suppressWriteRef) {
        suppressWriteRef.current = true;
    }
};

export const consumeSuppressedSessionWrite = (suppressWriteRef) => {
    if (!suppressWriteRef?.current) return false;
    suppressWriteRef.current = false;
    return true;
};
